<div>
  <div class="border-b border-gray-100 p-3 md:p-4">
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center space-x-2">
        <mat-icon class="text-green-500">analytics</mat-icon>
        <span class="text-xl font-semibold text-gray-800">Match Analysis</span>
      </div>
      @if (showCloseButton) {
      <button (click)="close()" mat-icon-button class="text-gray-500 hover:text-gray-700 transition-colors">
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
      }
    </div>
  </div>

  <div class="p-3 md:p-4">
    <div class="space-y-6">
      <!-- Match Score Section -->
      <div class="bg-gray-50 rounded-lg p-6 text-center">
        <div class="relative inline-block">
          <div class="w-32 h-32 rounded-full border-8 {{candidate?.resume_analysis?.transcription_analysis?.rating>5?'border-green-200':'border-yellow-200'}} flex items-center justify-center">
            <div class="text-3xl font-bold text-{{candidate?.resume_analysis?.transcription_analysis?.rating>5?'green':'yellow'}}-600">
              {{ candidate?.resume_analysis?.transcription_analysis?.rating * 10 }}%
            </div>
          </div>
          <!-- <mat-icon
            class="!flex items-center justify-center absolute bottom-2 right-2 bg-green-500 text-white rounded-full !p-4">check</mat-icon> -->
        </div>
        <p class="mt-3 text-gray-600 font-medium">Match Score Rate</p>
      </div>

      <div class="space-y-4">
        <div class="flex items-center space-x-2">
          <mat-icon class="text-green-500">summarize</mat-icon>
          <h3 class="text-lg font-semibold text-gray-700">Overall Analysis</h3>
        </div>
        <div class="bg-white rounded-lg p-3 md:p-4">
          <div class="flex items-start space-x-3">
            <p class="text-gray-700"> {{candidate?.resume_analysis?.resume_analysis?.overall_analysis}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
